import { List } from 'antd';
import React from 'react';
import { arrayOf, shape, bool } from 'prop-types';
import RouteItem from './RouteItem';

const RoutesList = ({ routes = [], loading = false }) => (
  <List
    loading={loading}
    dataSource={routes}
    renderItem={(item) => <RouteItem {...item} />}
  />
);

RoutesList.propTypes = {
  routes: arrayOf(shape({})),
  loading: bool,
};

export default RoutesList;
